import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { materialDark } from "react-syntax-highlighter/dist/esm/styles/prism";

const Chatbot = () => {
  const [messages, setMessages] = useState([
    { text: "¡Hola! Soy el asistente de Vanware. ¿En qué puedo ayudarte hoy?", sender: "assistant", role: "assistant" },
  ]);
  const [inputMessage, setInputMessage] = useState("");
  const chatBoxRef = useRef(null);

  const apiUrl = "https://chatbot-vanware.onrender.com/chat/";

  const handleSendMessage = async () => {
    if (inputMessage.trim() !== "") {
      const newMessages = [...messages, { text: inputMessage, sender: "user", role: "user" }];
      setMessages(newMessages);
      setInputMessage("");

      const lastMessage = messages[messages.length - 1];
      if (lastMessage && lastMessage.text === inputMessage) {
        // Si el mensaje es igual al último, no enviar de nuevo
        return;
      }

      try {
        const conversation = newMessages.map((message) => ({
          role: message.role,
          content: message.text,
        }));

        const response = await axios.post(apiUrl, { messages: conversation });
        if (response.status === 200) {
          const botMessages = response.data.messages.filter((msg) => msg.role === "assistant");
          const botResponse = botMessages.length > 0 ? botMessages[botMessages.length - 1].content : "Error procesando tu solicitud.";

          // Separar código del texto
          const formattedMessages = processBotResponse(botResponse);
          setMessages((prevMessages) => [...prevMessages, ...formattedMessages]);
        } else {
          setMessages((prevMessages) => [
            ...prevMessages,
            { text: "Error procesando tu solicitud.", sender: "assistant", role: "assistant" },
          ]);
        }
      } catch (error) {
        setMessages((prevMessages) => [
          ...prevMessages,
          { text: "Error procesando tu solicitud.", sender: "assistant", role: "assistant" },
        ]);
      }
    }
  };

  const processBotResponse = (response) => {
    const splitResponse = response.split(/```/); // Divide en bloques de texto y código
    return splitResponse.map((block, index) => {
      if (index % 2 === 1) {
        // Bloques impares son código
        return { text: block.trim(), sender: "assistant", role: "assistant", isCode: true };
      } else {
        // Bloques pares son texto
        return { text: block.trim(), sender: "assistant", role: "assistant", isCode: false };
      }
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  // Scroll automático al último mensaje
  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [messages]);

  const renderMessage = (message) => {
    if (message.isCode) {
      return (
        <SyntaxHighlighter language="javascript" style={materialDark}>
          {message.text}
        </SyntaxHighlighter>
      );
    }
    return <span>{message.text}</span>;
  };

  return (
    <div className="chat-container">
      <div className="chat-box" ref={chatBoxRef}>
        {messages.map((message, index) => (
          <div key={index} className={`chat-message ${message.sender === "assistant" ? "bot-message" : "user-message"}`}>
            {renderMessage(message)}
          </div>
        ))}
      </div>
      <div className="chat-input-container">
        <input
          type="text"
          className="chat-input"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Escribe tu mensaje aquí..."
        />
        <button onClick={handleSendMessage} className="chat-send-btn">
          Enviar
        </button>
      </div>
    </div>
  );
};

export default Chatbot;
